<template>
  <v-dialog
      v-model="show"
      v-if="show"
      width="70%"
      max-width="70%"
      scrollable
  >
    <v-card>
      <v-card-title class="titulo_card">{{ $t("Firma") }}</v-card-title>

      <v-card-text class="pt-1">
        <v-row>
          <v-col cols="12">
            <div class="container_info_azul">
              <p>{{ $t("Puedes firmar el documento utilizando el ratón, con una tableta digitalizadora, o con el dedo si utilizas una pantalla táctil.") }}</p>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <VueSignaturePad
                width="100%"
                height="500px"
                ref="signature_pad"
                :options="{ onBegin }"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pb-1">
            <div class="text-sm-right text-center">

              <v-btn @click="clear_signature" small class="ml-2" color="red">
                <v-icon small style="color: white">mdi-eraser</v-icon>
                <span style="color: white">{{ $t('Borrar') }}</span>
              </v-btn>

              <v-btn @click="save_signature" small class="primary ml-2" :disabled="!is_valid">
                <v-icon small>mdi-content-save</v-icon>
                {{ $t('Guardar firma') }}
              </v-btn>

              <v-btn small @click="show = false" class="ml-2">{{ $t("Continuar sin firmar") }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  name: 'DialogSignature',
  data(){
    return {
      show: false,
      is_valid: false
    }
  },

  methods: {
    open_dialog(){
      this.show = true
    },

    save_signature() {
      const { isEmpty, data } = this.$refs.signature_pad.saveSignature();
      if(!isEmpty){
        this.$emit('on_save_signature', data)
        this.show = false
      }
    },

    clear_signature(){
      this.$refs.signature_pad.clearSignature()
      this.is_valid = false
    },

    onBegin() {
      this.$refs.signature_pad.resizeCanvas()
      this.is_valid = true
    }
  },

  components: {
    VueSignaturePad: () => import('vue-signature-pad')
  }
}
</script>
